import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import logo1 from "../../images/logo1.png";
import logo2 from "../../images/logo2.png";
import logo3 from "../../images/logo3.png";
import logo4 from "../../images/logo4.png";

import poster1 from "../../images/poster1.png";
import poster2 from "../../images/poster2.png";
import poster3 from "../../images/poster3.png";
import poster4 from "../../images/poster4.png";
import poster5 from "../../images/poster5.png";
import poster6 from "../../images/poster6.png";
import poster7 from "../../images/poster7.png";
import poster8 from "../../images/poster8.png";
import poster9 from "../../images/poster9.png";
import poster10 from "../../images/poster10.png";
import poster11 from "../../images/poster11.png";
import poster12 from "../../images/poster12.png";
import poster13 from "../../images/poster13.png";
import poster14 from "../../images/poster14.png";
import poster15 from "../../images/poster15.png";
import poster16 from "../../images/poster16.png";
import poster17 from "../../images/poster17.png";
import poster18 from "../../images/poster18.png";
import poster19 from "../../images/poster19.png";
import poster20 from "../../images/poster20.png";
import poster22 from "../../images/poster22.png";
import poster23 from "../../images/poster23.png";
import poster24 from "../../images/poster24.png";
import poster25 from "../../images/poster25.png";
import poster26 from "../../images/poster26.png";
import FOGPOSTER from "../../images/FOGPOSTER.png";
import A4HPOSTER from "../../images/A4HPOSTER.png";
import poster27 from "../../images/poster27.png";
import poster28 from "../../images/poster28.png";
import DIWALI from "../../images/diwali.jpg";
import fog1 from "../../images/oldfog1.png";
import fog2 from "../../images/oldfog2.png";
import fog3 from "../../images/oldfog3.png";
import fog4 from "../../images/oldfog4.png";
import fog5 from "../../images/oldfog5.png";
import fog6 from "../../images/oldfog6.png";
import fog7 from "../../images/oldfog.png";
import newfog1 from "../../images/newfog1.png";
import newfog2 from "../../images/newfog2.png";
import newfog3 from "../../images/newfog3.png";
import newfog4 from "../../images/newfog4.png";
import newfog5 from "../../images/newfog5.png";
import newfog6 from "../../images/newfog6.png";
import newfog7 from "../../images/bhajan.png";
import most1 from "../../images/most1.jpg";
import most2 from "../../images/most2.jpg";
import most3 from "../../images/most3.jpg";
import gallery1 from "../../images/gallery1.jpg";
import gallery2 from "../../images/gallery2.jpg";
import gallery3 from "../../images/gallery3.jpg";
import gallery4 from "../../images/gallery4.jpg";
import gallery5 from "../../images/gallery5.jpg";
import gallery6 from "../../images/gallery6.jpg";
import gallery7 from "../../images/gallery7.jpg";
function A4HEVENTS() {
  const location = useLocation();
  const [showImageModal, setShowImageModal] = useState(false);
const [selectedImage, setSelectedImage] = useState(null);
const [selectedFlyerName, setSelectedFlyerName] = useState("");
const openImageViewer = (img) => {
  setSelectedImage(img);
  setShowImageModal(true);
};

const closeImageViewer = () => {
  setShowImageModal(false);
  setSelectedImage(null);
};
  

const mostEvents = [poster25, newfog4, newfog7, most1, most2, most3];
const galleryImages = [
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7
];
const logoData = [
  {
    image: logo1,
    name: "Americans4Hindus PAC - Political Action Committee Events",
    id: "pac",
  },
  {
    image: logo2,
    name: "Americans4Hindus - 501(C)(3) - Non Profit Organization Events",
    id: "npo",
  },

  // ⬅️ OLD 4TH LOGO MOVED TO 3RD
  {
    image: logo4,
    name: "Americans4Hindus - 501(C)(4) DAC (Dharma Action Council Events)",
    id: "dac",
  },

  // ⬅️ OLD 3RD LOGO MOVED TO 4TH
  {
    image: logo3,
    name: "Festival of Globe - 501(C)(3) Non Profit Organization Events",
    id: "fog",
  },
];
  useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex((prev) => 
      (prev + 1) % mostEvents.length
    );
  }, 3000);

  return () => clearInterval(interval);
}, [mostEvents.length]);

  const [showModal, setShowModal] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState("pac"); // Add here
  const [activeTab, setActiveTab] = useState("upcoming");
  const [slideIndex, setSlideIndex] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [galleryIndex, setGalleryIndex] = useState(0);  
  const closeModal = () => {
  setShowModal(false);
  setSelectedLogo(null);
};

const openFlyer = (name, orgId = "pac", tab = "upcoming") => {
  setSelectedFlyerName(name);
  setSelectedOrg(orgId);
  setShowModal(true);
  setSlideIndex(0);
  setActiveTab(tab);
};

useEffect(() => {

  const hash = location.hash.replace("#", "");

  if (!hash) return;

  const matchedLogo = logoData.find(
    (item) => item.id === hash
  );

  if (matchedLogo) {

    setTimeout(() => {

      openFlyer(matchedLogo.name, matchedLogo.id);

      const el = document.getElementById(hash);

      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

    }, 200);

  }

}, [location]);
const nextSlide = () => {
  setSlideIndex((prev) =>
    (prev + 1) % flyers[selectedOrg][activeTab].length
  );
};

const prevSlide = () => {
  setSlideIndex((prev) =>
    prev === 0
      ? flyers[selectedOrg][activeTab].length - 1
      : prev - 1
  );
};

const nextGallerySlide = () => {
  setGalleryIndex((prev) => (prev + 1) % galleryImages.length);
};

const prevGallerySlide = () => {
  setGalleryIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
};

const getGalleryPosition = (index) => {
  if (index === galleryIndex) return "active";
  if (index === (galleryIndex - 1 + galleryImages.length) % galleryImages.length) return "left";
  if (index === (galleryIndex + 1) % galleryImages.length) return "right";
  return "hidden";
};
const flyers = {
  pac: {
    upcoming: [poster27, poster24, A4HPOSTER],
    past: [newfog1, newfog2, newfog3, newfog4, newfog6, newfog7,poster1, poster2, poster3, poster4, poster5, poster6, poster7, poster8, poster9, poster10, poster11, poster12, poster13, poster14, poster15, poster16, poster17, poster18, poster19, poster20, poster22, poster23, poster24, poster25, poster26, poster25],
  },

  npo: {
    upcoming: [poster27, poster24, A4HPOSTER],
    past: [poster25, newfog1, newfog2, newfog3, newfog4, newfog6, newfog7, poster1, poster2, poster3, poster4, poster5, poster6, poster7, poster8, poster9, poster10, poster11, poster12, poster13, poster14, poster15, poster16, poster17, poster18, poster19, poster20, poster22, poster23, poster24, poster25, poster26],
  },

  dac: {
    upcoming: [poster27, poster24, A4HPOSTER],
    past: [poster25, newfog1, newfog2, newfog3, newfog4, newfog6, newfog7, poster1, poster2, poster3, poster4, poster5, poster6, poster7, poster8, poster9, poster10, poster11, poster12, poster13, poster14, poster15, poster16, poster17, poster18, poster19, poster20, poster22, poster23, poster24, poster25, poster26],
  },

  fog: {
    upcoming: [poster28, FOGPOSTER],
    past: [newfog1, newfog2, newfog3, newfog4, newfog6, newfog7,fog1, fog4, fog5, fog6, fog7],
  },
};
  return (
    <>
      <style>{`
      /* ==========================================
       A4H GALLERY
      ========================================== */

.a4h-gallery-section {
  width: 100%;
  padding: 70px 20px 90px;
  margin-top: 20px;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  text-align: center;
}

.a4h-gallery-heading {
  text-align: center;
  margin-bottom: 35px;
}

.a4h-gallery-heading h1 {
  font-size: 3rem;
  font-weight: 800;
  margin: 0;
  color: #111;
  text-transform: uppercase;
}

.a4h-gallery-heading::after {
  content: "";
  display: block;
  width: 90px;
  height: 3px;
  background: #c1931d;
  margin: 14px auto 0;
}

/* BIG SLIDESHOW */

.a4h-gallery-slider {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1280px;
  min-height: 800px;
  margin: 0 auto;
  perspective: 1200px;
}

.a4h-gallery-slider::after {
  content: "";
  display: block;
  height: 760px;
}

.a4h-gallery-slide {
  position: absolute;
  width: 620px;
  height: 760px;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.6s ease;
  box-shadow: 0 25px 50px rgba(0,0,0,0.4);
  background: #fff;
  cursor: pointer;
}

.a4h-gallery-slide.active {
  transform: translateX(0) scale(1);
  z-index: 3;
  opacity: 1;
}

.a4h-gallery-slide.left {
  transform: translateX(-430px) scale(0.72) rotateY(25deg);
  opacity: 0.6;
}

.a4h-gallery-slide.right {
  transform: translateX(430px) scale(0.72) rotateY(-25deg);
  opacity: 0.6;
}

.a4h-gallery-slide.hidden {
  opacity: 0;
  pointer-events: none;
}

.a4h-gallery-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  display: block;
}

/* GALLERY ARROWS */

.a4h-gallery-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  width: 60px;
  height: 60px;

  border: none;
  border-radius: 50%;

  background: rgba(255,255,255,0.9);
  backdrop-filter: blur(6px);
  color: #111;

  font-size: 28px;
  font-weight: bold;

  cursor: pointer;
  z-index: 5;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 8px 25px rgba(0,0,0,0.35);

  transition: 0.3s ease;
}

.a4h-gallery-arrow:hover {
  background: #ff8a00;
  color: #fff;
  transform: translateY(-50%) scale(1.1);
}

.a4h-gallery-arrow.left {
  left: -60px;
}

.a4h-gallery-arrow.right {
  right: -60px;
}
      /* ==========================================
   RESERVE YOUR SPOTS SECTION
========================================== */

.ticket-section{
    padding:90px 20px;
    background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
}

.ticket-grid{
    display:flex;
    justify-content:center;
    align-items:flex-start;   /* Important */
    gap:70px;
    flex-wrap:wrap;
    margin-top:60px;
}

.ticket-card{
    position:relative;
    width:100%;
    border-radius:26px;
    padding:3px;              /* Reduced border thickness */
    overflow:visible;

    background:linear-gradient(
        135deg,
        #fff7d1 0%,
        #ffe28a 12%,
        #ffd04d 24%,
        #f7b733 38%,
        #e89b18 52%,
        #d97a00 66%,
        #b86a00 82%,
        #ffd04d 100%
    );

    background-size:250% 250%;
    animation:borderGlow 6s ease infinite;

    box-shadow:
        0 8px 0 rgba(140,90,0,.75),
        0 18px 35px rgba(0,0,0,.22),
        0 30px 55px rgba(0,0,0,.15);

    transform:perspective(1500px) rotateX(5deg);
    transition:.35s ease;
}

.ticket-card img{
    width:100%;
    height:800px;
    object-fit:contain;
    object-position:center;
    display:block;
    border-radius:22px;
    background:#fff;
}

/* Premium Gold Border */
.ticket-card::before{
    content:"";
    position:absolute;
    inset:-8px;
    border-radius:28px;
    background:linear-gradient(
        135deg,
        #fff6c5,
        #ff9500ff,
        #d75509ff,
        #ff9500ff,
        #fff6c5
    );
    z-index:-1;
}

/* Bottom Shadow for 3D look */
.ticket-card::after{
    content:"";
    position:absolute;
    left:8%;
    right:8%;
    bottom:-18px;
    height:18px;
    border-radius:50%;
    background:rgba(0,0,0,.35);
    filter:blur(12px);
    z-index:-1;
}
.ticket-box{
    width:100%;
    max-width:1200px;
    display:flex;
    flex-direction:column;
    align-items:center;
}

.ticket-buttons{
    display:flex;
    flex-direction:column;
    gap:14px;
    margin-top:28px;
    width:100%;
}

.single-btn{
    margin-top:28px;
    width:300px;
}

.ticket-btn{
    display:flex;
    justify-content:center;
    align-items:center;

    width:100%;
    padding:14px 22px;

    text-decoration:none;
    color:#fff;
    font-size:18px;
    font-weight:700;
    letter-spacing:.5px;

    border-radius:14px;

    background:linear-gradient(180deg,#ffcf3d,#d88b00);

    border:2px solid #b77900;

    /* Permanent 3D button */
    box-shadow:
        0 6px 0 #8c5b00,
        0 12px 22px rgba(0,0,0,.28);

    transition:.2s;
}

.ticket-btn:active{
    transform:translateY(3px);
    box-shadow:
        0 3px 0 #8c5b00,
        0 6px 12px rgba(0,0,0,.22);
}
@keyframes borderGlow{
    0%{
        background-position:0% 50%;
    }
    50%{
        background-position:100% 50%;
    }
    100%{
        background-position:0% 50%;
    }
}
        .mt-4 { margin-top: 1.5rem !important; }

        html, body { overflow-x: hidden; }

        .main-heading h1 {
          font-size: 3rem;
          font-weight: 800;
          text-align: center;
          margin-bottom: 2rem;
        }

        .main-heading {
          text-align: center;
          position: relative;
          margin-bottom: 2.5rem;
        }

        .main-heading::after {
          content: "";
          display: block;
          width: 80px;
          height: 3px;
          background: #000;
          margin: 12px auto 0;
        }

        .image-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.85);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .image-modal-content {
          position: relative;
          max-width: 90%;
          max-height: 90%;
          background: #fff;
          padding: 10px;
          border-radius: 10px;
        }

        .image-modal-content img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          max-height: 85vh;
        }

        .close-btn {
  position: fixed;

  top: 20px;
  right: 20px;

  width: 60px;
  height: 60px;

  border: none;
  border-radius: 50%;

  background: rgba(255, 255, 255, 1);
  color: black;

  font-size: 36px;
  font-weight: 700;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  z-index: 100000;

  box-shadow:
    0 10px 30px rgba(255, 255, 255, 1);

  transition: 0.3s ease;
}


.image-close-btn{
  position: absolute;

  top: 18px;
  right: 18px;

  width: 58px;
  height: 58px;

  border: none;
  border-radius: 50%;

  background: rgba(0,0,0,0.82);
  color: white;

  font-size: 34px;
  font-weight: 700;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  z-index: 99999;

  box-shadow:
    0 10px 30px rgba(0,0,0,0.45);

  transition: 0.3s ease;
}

.image-close-btn:hover{
  transform: scale(1.1);

  background: rgba(0,0,0,0.96);
}
        .logo-section {
  width: 100vw;
  margin: 3rem 0 4rem;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  padding: 74px 24px 86px;
  background: #1b1b1b;
  border-top: 1px solid rgba(193,147,29,0.55);
  border-bottom: 1px solid rgba(193,147,29,0.25);
}
.events-org-title {
  margin: 0;
  text-align: center;
  color: #b8743d;
  font-size: 32px;
  line-height: 1.15;
  font-weight: 900;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.events-org-divider {
  position: relative;
  width: 140px;
  height: 1px;
  margin: 46px auto 72px;
  background: #b8743d;
}
.events-org-divider::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  background: #b8743d;
  transform: translate(-50%, -50%) rotate(45deg);
}
.logo-section .col-lg-4 {
  padding-left: 5px;
  padding-right: 5px;
}
.logo-section .row {
  margin: 0;
}
.logo-card {
  flex: 0 0 auto;        /* prevent stretching */
  
  width: 320px;           /* remove fixed 25% */
  max-width: 320px;
  aspect-ratio: unset;

  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  padding: 0;
  box-shadow: none;
  transition: 0.35s ease;
}

.logo-card img {
  width: 100%;
  max-width: 100%;
  max-height: none;
  object-fit: contain;

  /* White logo card over the black organization section */
  background: #ffffff;
  border: none;
  outline: none;

  border-radius: 28px;
  box-shadow:
    0 0 0 5px #c1931dff,
    0 0 0 9px rgba(105,88,0,0.55),
    0 12px 26px rgba(0,0,0,0.42);

  transition: 0.35s ease;
}

.logo-card img:focus,
.logo-card img:active {
  outline: none;
  border: none;
}

.logo-card img:hover {
  transform: scale(1.08);
}

.logo-card:hover {
  transform: translateY(-8px);
  box-shadow: none;
}
.logo-section .row {
  margin: 0;
}
.logo-flex {
  display: flex;
  justify-content: center;   /* center group */
  gap: 86px 72px;                 /* CONTROL GAP HERE */
  flex-wrap: wrap;
}

@media (min-width: 769px) {
  .logo-card {
    flex: 0 0 320px;
    max-width: 320px;
  }
}
.head-title {
  text-align: center;
  width: 100%;
  margin: 0 auto;
}
.flyer-container {
  width: 90vw;              /* ⬅️ increased from 75% → 90% */
  max-width: 1400px;        /* allow large screens */
  height: 85vh;             /* ⬅️ take vertical space too */

  background: linear-gradient(135deg, #bfae85, #9f9476);
  border-radius: 20px;
  padding: 40px;

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  overflow: hidden;         /* clean edges */
}

/* TOP BUTTONS */
.flyer-tabs {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  justify-content: center;
  width: 100%;
}

.tab {
  padding: 10px 20px;
  border-radius: 25px;
  border: 2px solid orange;
  background: transparent;
  color: #fff;
  cursor: pointer;
  font-weight: 600;
}

.tab.active {
  background: linear-gradient(45deg, #ff8c00, #ff5e00);
  border: none;
}
.most-events-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.most-events-section {
  text-align: center;
  margin: 60px 0;
}

/* FLEX ROW */
.most-events-row {
  position: relative;

  width: 100%;
  height: 650px;

  display: flex;
  align-items: center;
  justify-content: center;

  perspective: 2000px;

  overflow: hidden;
}

.event-card {
  position: absolute;

  transition:
    transform 1.1s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 1.1s ease,
    filter 1.1s ease;

  border-radius: 28px;
  overflow: hidden;

  background: white;

  box-shadow:
    0 25px 50px rgba(0,0,0,0.25);

  will-change: transform;
}

/* LEFT CARD */
.event-card.left {
  transform:
    translateX(-520px)
    scale(0.78)
    rotateY(28deg);

  opacity: 0.55;
  z-index: 1;

  filter: blur(1px);
}

/* CENTER CARD */
.event-card.center {
  transform:
    translateX(0)
    scale(1);

  opacity: 1;
  z-index: 5;
}

/* RIGHT CARD */
.event-card.right {
  transform:
    translateX(520px)
    scale(0.78)
    rotateY(-28deg);

  opacity: 0.55;
  z-index: 1;

  filter: blur(1px);
}


.event-card.center img {
  animation: smoothZoom 3.2s linear infinite;
}
@keyframes smoothZoom {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }

  100% {
    transform: scale(1);
  }
}
.event-card img {
  width: 650px;
  height: 520px;

  object-fit: contain;
  display: block;

  transition: 1s ease;
}
.arrow-btn {
  background: linear-gradient(135deg, #FFD700, #b8860b);
  color: #222;

  border: none;
  border-radius: 50%;

  width: 50px;
  height: 50px;

  font-size: 22px;
  font-weight: bold;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 6px 15px rgba(0,0,0,0.3);

  transition: all 0.3s ease;
}

.arrow-btn {
  position: relative;
  z-index: 10;
}

.arrow-btn:hover {
  transform: scale(1.15);
  box-shadow: 0 10px 20px rgba(0,0,0,0.4);
}
.image-viewer {
  position: relative;

  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;
}

.image-viewer img {
  width: auto;
  height: auto;

  max-width: 98vw;
  max-height: 98vh;

  object-fit: contain;

  border-radius: 18px;

  box-shadow:
    0 20px 60px rgba(0,0,0,0.6);
}
/* GRID */
.flyer-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  width: 100%;
  height: 100%;

  overflow: hidden;   /* ⬅️ remove scroll */
}

/* FLYER CARDS */
.flyer-grid img {
  width: 42%;              /* ⬅️ reduced size */
  max-width: 480px;        /* control max */
  max-height: 65vh;        /* ⬅️ ensures it fits vertically */

  object-fit: cover;     /* prevents cropping */
  
  border-radius: 15px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.4);

  transition: 0.3s;
}

.flyer-grid img:hover {
  transform: scale(1.08);
}
.flyer-title {
  color: white;
  font-size: 2rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 25px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
/* PREMIUM SLIDER */
.premium-slider {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 25px;
  position: relative;

  perspective: 1800px;
}

/* MAIN CENTER IMAGE */
.slide-main {
  width: auto;

  border-radius: 22px;
  overflow: hidden;

  transform: scale(1);

  z-index: 5;

  box-shadow: 0 20px 40px rgba(0,0,0,0.4);

  transition: 0.5s ease;

  display: flex;
  align-items: center;
  justify-content: center;
}

.slide-main img {
  width: auto;
  height: auto;

  max-width: 420px;   /* ⬅️ decrease poster size */
  max-height: 55vh;

  object-fit: contain;

  display: block;

  border-radius: 22px;
}

/* SIDE IMAGES */
.slide-side {
  width: auto;

  opacity: 0.7;

  filter: brightness(0.8);

  transform: scale(0.82);

  transition: 0.5s ease;

  border-radius: 18px;

  overflow: hidden;

  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.slide-side img {
  width: auto;
  height: auto;

  max-width: 220px;
  max-height: 48vh;

  object-fit: contain;

  display: block;

  border-radius: 18px;
}

/* ARROWS */
.slide-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  width: 58px;
  height: 58px;

  border-radius: 50%;
  border: none;

  background: linear-gradient(135deg, #ffb300, #ff6f00);
  color: white;

  font-size: 30px;
  font-weight: bold;

  cursor: pointer;
  z-index: 20;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 10px 25px rgba(0,0,0,0.35);

  transition: 0.3s ease;
}

.slide-arrow:hover {
  transform: translateY(-50%) scale(1.12);
}

.left-arrow {
  left: 10px;
}

.right-arrow {
  right: 10px;
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
.slide-main-wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    height: 100%;
}

/* VIEW BUTTON */
.view-btn{
  padding:12px 28px;
  flex-shrink: 0;
  margin-top: 8px;
  border:none;
  border-radius:40px;

  background:linear-gradient(
    135deg,
    #FFD700,
    #ff9800
  );

  color:#111;
  font-size:16px;
  font-weight:700;
  letter-spacing:0.5px;

  cursor:pointer;

  box-shadow:
    0 10px 25px rgba(0,0,0,0.25);

  transition:0.3s ease;
}

.view-btn:hover{
  transform:translateY(-3px) scale(1.05);

  box-shadow:
    0 15px 30px rgba(0,0,0,0.35);
}

.core-events-section {
  margin-top: 8rem;
}

.core-events-list {
  margin-bottom: 4rem;
}

.core-event-item {
  margin-top: 1.5rem;
}
/* =========================
   MOBILE UI
   ========================= */
@media (max-width: 768px) {
  .a4h-gallery-section {
  padding: 45px 12px 60px;
}

.a4h-gallery-heading h1 {
  font-size: 22px !important;
}

.a4h-gallery-slider {
  width: 100% !important;
  max-width: 100% !important;
  min-height: 0 !important;
  height: auto !important;
  margin: 16px auto !important;
  perspective: none !important;
  overflow: hidden !important;
}

.a4h-gallery-slider::after {
  height: 0 !important;
}

.a4h-gallery-slide {
  position: relative !important;
  width: 94% !important;
  max-width: 440px !important;
  height: auto !important;
  aspect-ratio: 4 / 5;
  max-height: 560px;
  transform: none !important;
  opacity: 1 !important;
  margin: 0 auto !important;
  left: 0 !important;
  right: 0 !important;
  box-shadow: 0 15px 35px rgba(0,0,0,0.22);
}

.a4h-gallery-slide.left,
.a4h-gallery-slide.right,
.a4h-gallery-slide.hidden {
  display: none !important;
}

.a4h-gallery-slide.active {
  display: block !important;
  transform: none !important;
  opacity: 1 !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.a4h-gallery-slide img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  object-position: center center !important;
  background: transparent !important;
}

.a4h-gallery-arrow {
  width: 36px !important;
  height: 36px !important;
  font-size: 18px;
  z-index: 5 !important;
}

.a4h-gallery-arrow.left {
  left: 6px !important;
}

.a4h-gallery-arrow.right {
  right: 6px !important;
}
  
  .ticket-section{
        padding:55px 15px;
    }

    .ticket-grid{
        gap:22px;
        margin-top:35px;
    }

    .ticket-card{
    width:95%;
    max-width:600px;
}

.ticket-card img{
    width:100%;
    height:240px;
    object-fit:cover;
}
    .ticket-box{
        width:100%;
    }

    .ticket-btn{
        font-size:16px;
        padding:10px 16px;
    }

    .single-btn{
        width:90%;
    }

  .block.color-scheme-4 {
    padding-top: 8px !important;
    padding-bottom: 20px !important;
  }

  .hra-topTitle,
  h1.head-title {
    font-size: 22px !important;
    line-height: 1.25 !important;
    margin: 8px 0 0 !important;
    padding: 0 10px;
  }

  .section-divider {
    margin: 12px auto 18px !important;
    gap: 10px !important;
  }

  .section-divider span {
    font-size: 16px !important;
  }

  /* Org logos: compact 2x2 grid */
  .logo-section {
    margin-top: 12px !important;
    margin-bottom: 24px !important;
    padding: 36px 14px 44px !important;
  }

  .events-org-title {
    font-size: 22px !important;
  }

  .events-org-divider {
    width: 96px !important;
    margin: 22px auto 28px !important;
  }

  .logo-flex {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
    justify-content: stretch !important;
  }

  .logo-section > div {
    margin-top: 12px !important;
  }

  .logo-card {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .logo-card:hover {
    transform: none;
  }

  .logo-card img {
    width: 100% !important;
    max-width: 100% !important;
    max-height: none !important;
    height: auto !important;
    border-radius: 16px !important;
    box-shadow:
      0 0 0 4px #c1931dff,
      0 4px 12px rgba(0,0,0,0.35) !important;
  }

  .logo-card img:hover {
    transform: none;
  }

  /* Most recent events carousel */
  .most-events-section {
    margin: 28px 0 20px !important;
    padding: 0 8px;
  }

  .main-heading {
    margin-bottom: 14px !important;
  }

  .main-heading h1 {
    font-size: 20px !important;
    line-height: 1.25 !important;
    margin-bottom: 0.5rem !important;
  }

  .main-heading::after {
    width: 56px;
    height: 2px;
    margin-top: 8px;
  }

  .most-events-row {
    height: 280px !important;
    perspective: 900px;
  }

  .event-card.left {
    transform: translateX(-42%) scale(0.72) rotateY(18deg) !important;
    opacity: 0.45;
    filter: blur(0.5px);
  }

  .event-card.right {
    transform: translateX(42%) scale(0.72) rotateY(-18deg) !important;
    opacity: 0.45;
    filter: blur(0.5px);
  }

  .event-card.center {
    transform: translateX(0) scale(1) !important;
  }

  .event-card {
    border-radius: 16px !important;
  }

  .event-card img,
  .event-card.center img {
    width: min(78vw, 300px) !important;
    height: 220px !important;
    object-fit: contain !important;
    animation: none !important;
  }

  /* Core events */
  .core-events-section {
    margin-top: 1.5rem !important;
    padding: 0 12px 24px !important;
  }

  .core-events-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    margin: 12px 0 28px !important;
  }

  .core-event-item {
    margin-top: 0 !important;
  }

  .core-event-item h3.white {
    font-size: 12px !important;
    line-height: 1.3 !important;
    margin: 0 !important;
    padding: 8px 12px;
    border-radius: 999px;
    background: rgba(255,255,255,0.55);
    border: 1px solid rgba(0,0,0,0.08);
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
    white-space: nowrap;
  }

  h1.white {
    font-size: 20px !important;
    line-height: 1.25 !important;
    margin: 8px 0 !important;
  }

  /* Flyer modal (DAC / PAC / NPO / FOG) */
  .image-modal {
    align-items: flex-start !important;
    padding: 64px 10px 16px !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .flyer-container {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    max-height: none !important;
    min-height: 0 !important;
    padding: 16px 12px 20px !important;
    border-radius: 16px !important;
    overflow: visible !important;
  }

  .flyer-title {
    font-size: 14px !important;
    line-height: 1.35 !important;
    margin: 0 36px 12px !important;
    letter-spacing: 0.3px !important;
    padding-top: 4px;
  }

  .image-close-btn {
    top: 10px !important;
    right: 10px !important;
    width: 36px !important;
    height: 36px !important;
    font-size: 22px !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.35) !important;
  }

  .flyer-tabs {
    gap: 8px !important;
    margin-bottom: 14px !important;
    flex-wrap: wrap;
  }

  .tab {
    flex: 1 1 auto;
    min-width: 0;
    padding: 9px 12px !important;
    font-size: 12px !important;
    border-radius: 999px !important;
    text-align: center;
  }

  .premium-slider {
    height: auto !important;
    gap: 0 !important;
    perspective: none !important;
    min-height: 0 !important;
  }

  .slide-side {
    display: none !important;
  }

  .slide-main-wrapper {
    width: 100%;
    gap: 12px !important;
  }

  .slide-main {
    width: 100% !important;
    max-width: 280px;
    margin: 0 auto;
    border-radius: 14px !important;
  }

  .slide-main img {
    width: 100% !important;
    max-width: 280px !important;
    max-height: 52vh !important;
    height: auto !important;
    border-radius: 14px !important;
  }

  .slide-arrow {
    width: 36px !important;
    height: 36px !important;
    font-size: 18px !important;
  }

  .left-arrow { left: 2px !important; }
  .right-arrow { right: 2px !important; }

  .view-btn {
    padding: 10px 22px !important;
    font-size: 14px !important;
    width: auto;
    min-width: 120px;
  }

  /* Full image viewer */
  .image-viewer {
    padding: 12px !important;
    height: auto !important;
    min-height: 100%;
  }

  .image-viewer img {
    max-width: 100% !important;
    max-height: 80vh !important;
    border-radius: 12px !important;
  }

  .close-btn {
    top: 12px !important;
    right: 12px !important;
    width: 40px !important;
    height: 40px !important;
    font-size: 24px !important;
  }
}

@media (max-width: 480px) {
  .hra-topTitle,
  h1.head-title {
    font-size: 20px !important;
  }

  .logo-flex {
    gap: 10px !important;
  }

  .logo-card img {
    border-radius: 14px !important;
    box-shadow:
      0 0 0 3px #c1931dff,
      0 3px 10px rgba(0,0,0,0.35) !important;
  }

  .logo-card {
    box-shadow: none !important;
  }

  .most-events-row {
    height: 240px !important;
  }

  .event-card img,
  .event-card.center img {
    width: min(72vw, 260px) !important;
    height: 190px !important;
  }

  .flyer-title {
    font-size: 13px !important;
  }

  .slide-main,
  .slide-main img {
    max-width: 240px !important;
  }
  
}
      `}</style>

      <section>
        <div className="block color-scheme-4">
          
          
          
<div className="container">
  <div className="row justify-content-center">
    <div className="col-md-10 col-lg-9">
      <div className="container text-center">
  <h1 className="head-title hra-topTitle">EVENTS & CALENDAR</h1>
  <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div>
</div>
    </div>
  </div>
</div>

{/* LOGOS SECTION */}
<div className="container-fluid logo-section">
  <h2 className="events-org-title">OUR ORGANIZATION EVENTS</h2>
  <div className="events-org-divider" />
  <div className="logo-flex">
    {logoData.map((logo, index) => (
      <div
        className="logo-card"
        key={logo.id || index}
        id={logo.id}
      >
        <img
          src={logo.image}
          alt={logo.name}
          onClick={() => openFlyer(logo.name, logo.id)}
        />
      </div>
    ))}
  </div>
</div>
 

<div className="ticket-section">
  <div className="container">

    <div className="main-heading">
      <h1>RESERVE YOUR SPOTS / GRAB YOUR TICKETS</h1>
    </div>

    <div className="ticket-grid">

  {/* 
  <div className="ticket-box">
    <div className="ticket-card">
      <img src={poster25} alt="Ticket 1" />
    </div>

    <div className="ticket-buttons">
      <a
        href="https://www.marriott.com/event-reservations/reservation-link.mi?id=1781552396410&key=GRP&app=resvlink&_branch_match_id=1596215839044512886&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXTywo0MtNLCrKzC8p0UvOz9UvSi0uy0wtN7IHytiCODmZedlqmSm2huYWhqamRsaWZiaGBmrZqZW27kEBanVFqWmpQO156fFJRfnlxalFts4ZRfm5qQAoOPSiYQAAAA%3D%3D"
        target="_blank"
        rel="noopener noreferrer"
        className="ticket-btn"
      >
        BOOK TOUR HOTEL ROOM 
      </a>

      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSdTsc8bAH_FshpkqjxaIHqcPUZdOaxm0d_5sw5cY7QMevQaXQ/viewform"
        target="_blank"
        rel="noopener noreferrer"
        className="ticket-btn"
      >
        RSVP FOR ALL EVENTS
      </a>

      <a
        href="https://secure.anedot.com/a4h/donate"
        target="_blank"
        rel="noopener noreferrer"
        className="ticket-btn"
      >
        DONATE & SUPPORT
      </a>
    </div>
  </div>
*/}
  
  <div className="ticket-box">
    <div className="ticket-card">
      <img src={DIWALI} alt="Ticket 2" />
    </div>

    <a
      href="https://givebutter.com/fogdiwali"
      target="_blank"
      rel="noopener noreferrer"
      className="ticket-btn single-btn"
    >
      RESERVE YOUR TICKET(S)
    </a>
  </div>

  {
  <div className="ticket-box">
    <div className="ticket-card">
      <img src={newfog7} alt="Ticket 3" />
    </div>

    <a
      href="https://givebutter.com/A4HMI26"
      target="_blank"
      rel="noopener noreferrer"
      className="ticket-btn single-btn"
    >
      RESERVE YOUR TICKET(S)
    </a>
    <Link
  to="/bhajanclubbing"
  className="ticket-btn single-btn"
>
    EXPLORE BHANJAN CLUBBING EVENTS
</Link>
  </div>
}
</div>

  </div>
</div>




    <div className="most-events-section">

  <div className="main-heading">
    <h1>OUR MOST RECENT EVENTS</h1>
  </div>

  <div className="most-events-row">

  

  {/* IMAGE 1 */}
{mostEvents.map((img, index) => {

  const leftIndex =
    currentIndex === 0
      ? mostEvents.length - 1
      : currentIndex - 1;

  const rightIndex =
    (currentIndex + 1) % mostEvents.length;

  // SHOW ONLY 3 IMAGES
  if (
    index !== leftIndex &&
    index !== currentIndex &&
    index !== rightIndex
  ) {
    return null;
  }

  let position = "";

  if (index === currentIndex) {
    position = "center";
  } else if (index === leftIndex) {
    position = "left";
  } else {
    position = "right";
  }

  return (
    <div
      key={index}
      className={`event-card ${position}`}
    >
      <img
        src={img}
        alt=""
        onClick={() => openImageViewer(img)}
      />
    </div>
  );

})}

  

</div>

</div>
{/* ==========================================
    A4H GALLERY
========================================== */}

<div className="a4h-gallery-section">

  <div className="a4h-gallery-heading">
    <h1>A4H GALLERY</h1>
  </div>

  <div className="a4h-gallery-slider">

    <button
      className="a4h-gallery-arrow left"
      onClick={prevGallerySlide}
      aria-label="Previous gallery image"
    >
      &#10094;
    </button>

    <button
      className="a4h-gallery-arrow right"
      onClick={nextGallerySlide}
      aria-label="Next gallery image"
    >
      &#10095;
    </button>

    {galleryImages.map((image, index) => {
      const position = getGalleryPosition(index);

      return (
        <div
        key={index}
        className={`a4h-gallery-slide ${position}`}
        onClick={() => {
          if (position === "active") {
            openImageViewer(image);
          } else {
            setGalleryIndex(index);
          }
        }}
      >
        <img src={image} alt={`A4H Gallery ${index + 1}`} />
      </div>
      );
    })}

  </div>

</div>
       {/* EVENTS LIST */}
          <div className="container core-events-section">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">

                    <div className="main-heading">
                      <h1 className="white">OUR CORE EVENTS</h1>
                    </div>

                    <div className="core-events-list">
                    {[
                      "Republic Day",
                      "Holi",
                      "Independence Day",
                      "India Day Parade",
                      "Freedom Gala",
                      "Idol",
                      "Navaratri",
                      "Diwali",
                      "Telugu Sankranti",
                      "Leadership & Civic Initiatives",
                      "Year-Round Vision"
                    ].map((event, index) => (
                      <div
                        key={index}
                        className="core-event-item"
                      >
                        <h3 className="white">
                          <span>❖</span> {event}
                        </h3>
                      </div>
                    ))}
                    </div>

                  </article>
                </div>
              </div>
            </div>
          </div>

        </div>

        {showModal && (
  <div className="image-modal" onClick={closeModal}>
    <div
      className="flyer-container"
      onClick={(e) => e.stopPropagation()}
    >
      <button
  className="image-close-btn"
  onClick={closeModal}
>
  ×
</button>

      {/* TOP BUTTONS */}
      <h2 className="flyer-title">
  {selectedFlyerName}
</h2>

{/* TOP BUTTONS */}
<div className="flyer-tabs">
  <button
    className={`tab ${activeTab === "upcoming" ? "active" : ""}`}
    onClick={() => {
  setActiveTab("upcoming");
  setSlideIndex(0);
}}
  >
    Upcoming Events
  </button>

  <button
    className={`tab ${activeTab === "past" ? "active" : ""}`}
    onClick={() => {
  setActiveTab("past");
  setSlideIndex(0);
}}
  >
    Past Events
  </button>
</div>
      
      {/* FLYERS */}
{/* PREMIUM SLIDESHOW */}
<div className="premium-slider">

  {/* LEFT BUTTON */}
  <button className="slide-arrow left-arrow" onClick={prevSlide}>
    ❮
  </button>

  {/* PREV IMAGE */}
  <div className="slide-side">
    <img
      src={
        flyers[selectedOrg][activeTab][
          slideIndex === 0
            ? flyers[selectedOrg][activeTab].length - 1
            : slideIndex - 1
        ]
      }
      alt="prev"
    />
  </div>

 
  {/* MAIN IMAGE */}
<div className="slide-main-wrapper">

  <div className="slide-main">
    <img
      src={flyers[selectedOrg][activeTab][slideIndex]}
      alt="main"
    />
  </div>

  <button
    className="view-btn"
    onClick={() =>
      openImageViewer(flyers[selectedOrg][activeTab][slideIndex])
    }
  >
    View
  </button>

</div>

  {/* NEXT IMAGE */}
  <div className="slide-side">
    <img
      src={
        flyers[selectedOrg][activeTab][
          (slideIndex + 1) % flyers[selectedOrg][activeTab].length
        ]
      }
      alt="next"
    />
  </div>

  {/* RIGHT BUTTON */}
  <button className="slide-arrow right-arrow" onClick={nextSlide}>
    ❯
  </button>

</div>
    </div>
  </div>
)}
{/* ✅ PASTE HERE EXACTLY 👇 */}
{showImageModal && (
  <div className="image-modal" onClick={closeImageViewer}>
    
    <div className="image-viewer" onClick={(e) => e.stopPropagation()}>
      
      <button className="close-btn" onClick={closeImageViewer}>×</button>

      <img src={selectedImage} alt="full" />

    </div>

  </div>
)}
      </section>
    </>
  );
}

export default A4HEVENTS;
